var locales = require('./locales.json')
var template = require('./index.html')
var t = require('../translate')

module.exports = {
  data: data,
  created() {
    this.products[0].description = require('./hallofrunes_desc.html')
    //this.products[1].description = require('./tarot3d_desc.html')
    this.products[1].description = require('./dailyrune_desc.html')
  },
  template: template,
  components: {
    'app-header': require('../header'),
    'app-overview': require('../overview'),
    'app-showcase': require('../showcase'),
    'app-footer': require('../footer'),
    'app-runes-set-order': require('../runes-set-order'),
    'app-bought-modal': require('../runes-set-order/bought_modal')
  },
  methods: {
    slideto: require('../animation/slideto')
  },
  beforeRouteEnter(to, from, next) {    
    next(vm => {
      if(to.path === '/bought') {
          vm.bought = true;
          if (typeof window !== 'undefined') {
            window.location = '#modal-bought';
          }
      }
    })
  }
}

function data () {
  return {
    bought: false,
    products: [
      {
        featured: true,
        title: t(locales, 'products.hallofrunes.title'),
        img: require('assets/halle_der_runen_karten_banner_256x256.png'),
        img_big: require('assets/halle_der_runen_karten_banner_2_600x398.jpg'),
        description: t(locales, 'products.hallofrunes.description'),
        id: 'js-prod-0'
      },
      /*{
        title: t(locales, 'products.tarot3d.title'),
        img: require('assets/tarot3d_256x256.png'),
        img_big: require('assets/tarot3d_600x314.jpg'),
        description: t(locales, 'products.tarot3d.description'),
        id: 'js-prod-1',
        url: 'https://www.tarot3d.net'
      },*/
      {
        title: t(locales, 'products.dailyrunes.title'),
        img: require('assets/tagesrune_256x256.png'),
        img_big: require('assets/tagesrune_600x314.jpg'),
        description: t(locales, 'products.dailyrunes.description'),
        id: 'js-prod-2',
        url: 'https://daily.tarot3d.net/'
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./lib/home-view/index.js